import captchaGoogleV2 from './img-captchaGoogleV2.png';
import captchaGoogleV3 from './img-captchaGoogleV3.png'
import captchaNativo from './img-captchaNativo.png'
export default {
    "Bsr Nativo 1":captchaNativo,
    "Google reCAPTCHA v2":captchaGoogleV2,
    "Google reCAPTCHA v3":captchaGoogleV3
}